import { render } from "./MoveToPopUp.vue?vue&type=template&id=238db28f&scoped=true&ts=true"
import script from "./MoveToPopUp.vue?vue&type=script&lang=ts"
export * from "./MoveToPopUp.vue?vue&type=script&lang=ts"

import "./MoveToPopUp.vue?vue&type=style&index=0&id=238db28f&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-238db28f"]])

export default __exports__